// import React, { useState, useEffect, useRef } from "react";
// import css from "./card.module.css";
// import { HandySvg } from "handy-svg";
// import iconSrc from "../../../svg/xCardIcon.svg";
// import ProdInCard from "./prodInCard";
// import { collection, getDocs } from "firebase/firestore";
// import { db } from "../../../firebase";
// import { useNavigate } from "react-router-dom";

// export default function Card({
//   setCart,
//   setCountProductForCart,
//   setCartCounterC,
// }) {
//   const [cartProducts, setCartProducts] = useState([]);
//   const [finishPrice, setFinishPrice] = useState(0);
//   const navigate = useNavigate();
//   const popUpRef = useRef(null);

//   useEffect(() => {
//     const fetchProducts = async () => {
//       const productsSnapshot = await getDocs(collection(db, "product"));
//       const allProducts = productsSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const bundlesSnapshot = await getDocs(collection(db, "bundles"));
//       const bundles = bundlesSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const actionsSnapshot = await getDocs(collection(db, "actions"));
//       const actions = actionsSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const cartItems = JSON.parse(localStorage.getItem("cart")) || [];

//       const now = new Date();

//       // Крок 1: сформуй повний список товарів у кошику
//       let productsInCart = cartItems.map((item) => {
//         const found = allProducts.find((p) => p.id === item.uid);
//         return { ...found, quantity: item.quantity, uid: found.id };
//       });

//       // Крок 2: знайди товари, які належать до однієї зв’язки (бандлу)
//       bundles.forEach((bundle) => {
//         const bundleProductIds = bundle.products.map((p) => p.productId);

//         const matchingProducts = productsInCart.filter((p) =>
//           bundleProductIds.includes(p.id)
//         );

//         // if (matchingProducts.length >= 2) {
//         //   // Якщо є мінімум 2 товари зв’язки у кошику — знайди другий і постав йому знижку
//         //   let found = 0;
//         //   for (let i = 0; i < productsInCart.length; i++) {
//         //     const product = productsInCart[i];
//         //     if (bundleProductIds.includes(product.id)) {
//         //       found += 1;
//         //       if (found === 2) {
//         //         // Застосуй знижку тільки до другого знайденого
//         //         const bundleDiscount = bundle.products.find(
//         //           (p) => p.productId === product.id
//         //         )?.discount;

//         //         product.bundleDiscount = bundleDiscount || 0;
//         //         break; // лише до 1 продукту!
//         //       }
//         //     }
//         //   }
//         // }
//         if (matchingProducts.length >= bundle.products.length) {
//           productsInCart = productsInCart.map((product) => {
//             const bundleProduct = bundle.products.find(
//               (p) => p.productId === product.id
//             );

//             if (bundleProduct) {
//               return {
//                 ...product,
//                 bundleDiscount: bundleProduct.discount,
//               };
//             }

//             return product;
//           });
//         }
//       });

//       // Крок 3: застосуй акційні знижки
//       const updated = productsInCart.map((p) => {
//         let finalPrice = p.price;

//         const matchedAction = actions.find((action) => {
//           const start = action.startDate ? new Date(action.startDate) : null;
//           const end = new Date(action.endDate);

//           const matchProduct = action.appliesTo.products?.includes(p.id);

//           const productSeries = Array.isArray(p.seria)
//             ? p.seria
//             : typeof p.seria === "string" && p.seria !== ""
//             ? [p.seria]
//             : [];

//           const matchSeries = productSeries.some((ser) =>
//             action.appliesTo.series?.includes(ser)
//           );

//           const productAuthors = Array.isArray(p.textAutor)
//             ? p.textAutor.map((a) => a.split(" ")[0].trim())
//             : typeof p.textAutor === "string" && p.textAutor !== ""
//             ? [p.textAutor.split(" ")[0].trim()]
//             : [];

//           const actionAuthors = Array.isArray(action.appliesTo.authors)
//             ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
//             : [];

//           const matchAuthor = productAuthors.some((a) =>
//             actionAuthors.includes(a)
//           );

//           return (
//             (matchProduct || matchSeries || matchAuthor) &&
//             (!start || now >= start) &&
//             now <= end
//           );
//         });

//         if (matchedAction?.discountPercent) {
//           finalPrice = Math.round(
//             finalPrice - (finalPrice * matchedAction.discountPercent) / 100
//           );
//           p.isActionPrice = true;
//         }

//         if (p.bundleDiscount) {
//           finalPrice = Math.round(
//             finalPrice - (finalPrice * p.bundleDiscount) / 100
//           );
//           p.isBundlePrice = true;
//         }

//         p.finalPrice = finalPrice;
//         return p;
//       });

//       setCartProducts(updated);
//     };

//     fetchProducts();
//   }, []);

//   useEffect(() => {
//     const total = cartProducts.reduce(
//       (acc, p) => acc + p.finalPrice * p.quantity,
//       0
//     );
//     const totalQty = cartProducts.reduce((acc, p) => acc + p.quantity, 0);
//     setFinishPrice(total);
//     setCountProductForCart(totalQty);
//   }, [cartProducts]);

//   const cartClose = () => setCart(false);

//   const handleQuantityChange = (uid, qty) => {
//     const updated = cartProducts.map((p) =>
//       p.uid === uid ? { ...p, quantity: qty } : p
//     );

//     const cartLS = JSON.parse(localStorage.getItem("cart")).map((p) =>
//       p.uid === uid ? { ...p, quantity: qty } : p
//     );
//     localStorage.setItem("cart", JSON.stringify(cartLS));
//     setCartProducts(updated);
//     setCartCounterC((prev) => prev + 1);
//   };

//   const removeProduct = (uid) => {
//     const updated = cartProducts.filter((p) => p.uid !== uid);
//     const cartLS = JSON.parse(localStorage.getItem("cart")).filter(
//       (p) => p.uid !== uid
//     );
//     localStorage.setItem("cart", JSON.stringify(cartLS));
//     setCartProducts(updated);
//     setCartCounterC((prev) => prev + 1);
//   };

//   const popUpRefHandler = (e) => {
//     if (popUpRef.current && !popUpRef.current.contains(e.target)) {
//       cartClose();
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", popUpRefHandler);
//     return () => document.removeEventListener("mousedown", popUpRefHandler);
//   }, []);

//   const goToOrder = () => {
//     if (cartProducts.length > 0) {
//       setCart(false);
//       navigate("/order");
//     }
//   };

//   return (
//     <div className={css.cardWrap}>
//       <div className={css.popUpWrap} ref={popUpRef}>
//         <div className={css.nameCountWrap}>
//           <h2 className={css.countH2}>Ваш кошик ({cartProducts.length})</h2>
//           <HandySvg
//             onClick={cartClose}
//             src={iconSrc}
//             width="28"
//             height="28"
//             className={css.countSvg}
//           />
//         </div>

//         <div className={css.productInCardWrap}>
//           {cartProducts.map((el, index) => (
//             <ProdInCard
//               key={index}
//               el={el}
//               handleQuantityChange={handleQuantityChange}
//               removeProduct={removeProduct}
//             />
//           ))}
//         </div>

//         <div className={css.fullPriceBlockWrap}>
//           <h3 className={css.finalPrice}>Всього: {finishPrice} грн</h3>
//           <div className={css.buttonPriceWrap}>
//             <div className={css.nextJoin} onClick={cartClose}>
//               Продовжити вибір
//             </div>
//             <div className={css.finalOrder} onClick={goToOrder}>
//               Оформити замовлення
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect, useRef } from "react";
import css from "./card.module.css";
import { HandySvg } from "handy-svg";
import iconSrc from "../../../svg/xCardIcon.svg";
import ProdInCard from "./prodInCard";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";
import { useNavigate } from "react-router-dom";

export default function Card({
  setCart,
  setCountProductForCart,
  setCartCounterC,
}) {
  const [cartProducts, setCartProducts] = useState([]);
  const [finishPrice, setFinishPrice] = useState(0);
  const navigate = useNavigate();
  const popUpRef = useRef(null);

  // useEffect(() => {
  //   const fetchProducts = async () => {
  //     const productsSnapshot = await getDocs(collection(db, "product"));
  //     const allProducts = productsSnapshot.docs.map((doc) => ({
  //       id: doc.id,
  //       ...doc.data(),
  //     }));

  //     const bundlesSnapshot = await getDocs(collection(db, "bundles"));
  //     const bundles = bundlesSnapshot.docs.map((doc) => ({
  //       id: doc.id,
  //       ...doc.data(),
  //     }));

  //     const actionsSnapshot = await getDocs(collection(db, "actions"));
  //     const actions = actionsSnapshot.docs.map((doc) => ({
  //       id: doc.id,
  //       ...doc.data(),
  //     }));

  //     const cartItems = JSON.parse(localStorage.getItem("cart")) || [];

  //     const now = new Date();

  //     // Крок 1: сформуй повний список товарів у кошику
  //     let productsInCart = cartItems.map((item) => {
  //       const found = allProducts.find((p) => p.id === item.uid);
  //       return { ...found, quantity: item.quantity, uid: found.id };
  //     });

  //     // Крок 2: знайди товари, які належать до однієї зв’язки (бандлу)
  //     bundles.forEach((bundle) => {
  //       const bundleProductIds = bundle.products.map((p) => p.productId);

  //       const matchingProducts = productsInCart.filter((p) =>
  //         bundleProductIds.includes(p.id)
  //       );

  //       // if (matchingProducts.length >= 2) {
  //       //   // Якщо є мінімум 2 товари зв’язки у кошику — знайди другий і постав йому знижку
  //       //   let found = 0;
  //       //   for (let i = 0; i < productsInCart.length; i++) {
  //       //     const product = productsInCart[i];
  //       //     if (bundleProductIds.includes(product.id)) {
  //       //       found += 1;
  //       //       if (found === 2) {
  //       //         // Застосуй знижку тільки до другого знайденого
  //       //         const bundleDiscount = bundle.products.find(
  //       //           (p) => p.productId === product.id
  //       //         )?.discount;

  //       //         product.bundleDiscount = bundleDiscount || 0;
  //       //         break; // лише до 1 продукту!
  //       //       }
  //       //     }
  //       //   }
  //       // }
  //       if (matchingProducts.length >= bundle.products.length) {
  //         productsInCart = productsInCart.map((product) => {
  //           const bundleProduct = bundle.products.find(
  //             (p) => p.productId === product.id
  //           );

  //           if (bundleProduct) {
  //             return {
  //               ...product,
  //               bundleDiscount: bundleProduct.discount,
  //             };
  //           }

  //           return product;
  //         });
  //       }
  //     });

  //     // Крок 3: застосуй акційні знижки
  //     const updated = productsInCart.map((p) => {
  //       let finalPrice = p.price;

  //       const matchedAction = actions.find((action) => {
  //         const start = action.startDate ? new Date(action.startDate) : null;
  //         const end = new Date(action.endDate);

  //         const matchProduct = action.appliesTo.products?.includes(p.id);

  //         const productSeries = Array.isArray(p.seria)
  //           ? p.seria
  //           : typeof p.seria === "string" && p.seria !== ""
  //           ? [p.seria]
  //           : [];

  //         const matchSeries = productSeries.some((ser) =>
  //           action.appliesTo.series?.includes(ser)
  //         );

  //         const productAuthors = Array.isArray(p.textAutor)
  //           ? p.textAutor.map((a) => a.split(" ")[0].trim())
  //           : typeof p.textAutor === "string" && p.textAutor !== ""
  //           ? [p.textAutor.split(" ")[0].trim()]
  //           : [];

  //         const actionAuthors = Array.isArray(action.appliesTo.authors)
  //           ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
  //           : [];

  //         const matchAuthor = productAuthors.some((a) =>
  //           actionAuthors.includes(a)
  //         );

  //         return (
  //           (matchProduct || matchSeries || matchAuthor) &&
  //           (!start || now >= start) &&
  //           now <= end
  //         );
  //       });

  //       if (matchedAction?.discountPercent) {
  //         finalPrice = Math.round(
  //           finalPrice - (finalPrice * matchedAction.discountPercent) / 100
  //         );
  //         p.isActionPrice = true;
  //       }

  //       if (p.bundleDiscount) {
  //         finalPrice = Math.round(
  //           finalPrice - (finalPrice * p.bundleDiscount) / 100
  //         );
  //         p.isBundlePrice = true;
  //       }

  //       p.finalPrice = finalPrice;
  //       return p;
  //     });

  //     setCartProducts(updated);
  //   };

  //   fetchProducts();
  // }, []);
  useEffect(() => {
    const fetchProducts = async () => {
      const productsSnapshot = await getDocs(collection(db, "product"));
      const allProducts = productsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const bundlesSnapshot = await getDocs(collection(db, "bundles"));
      const bundles = bundlesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const actionsSnapshot = await getDocs(collection(db, "actions"));
      const actions = actionsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // ⬇️ додали розпродажі
      const salesSnapshot = await getDocs(collection(db, "sales"));
      const sales = salesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const cartItems = JSON.parse(localStorage.getItem("cart")) || [];
      const now = new Date();

      // 1) формуємо список товарів у кошику
      let productsInCart = cartItems
        .map((item) => {
          const found = allProducts.find((p) => p.id === item.uid);
          if (!found) return null;
          return {
            ...found,
            quantity: item.quantity,
            uid: found.id, // вирівнюємо ідентифікатор
          };
        })
        .filter(Boolean);

      // 2) застосовуємо знижки бандлів (як і було)
      bundles.forEach((bundle) => {
        const bundleProductIds = (bundle.products || []).map(
          (p) => p.productId,
        );

        const inCartAllBundle =
          bundleProductIds.length > 0 &&
          bundleProductIds.every((pid) =>
            productsInCart.some((p) => p.id === pid),
          );

        if (inCartAllBundle) {
          productsInCart = productsInCart.map((product) => {
            const bundleProduct = (bundle.products || []).find(
              (p) => p.productId === product.id,
            );
            return bundleProduct
              ? { ...product, bundleDiscount: bundleProduct.discount }
              : product;
          });
        }
      });

      // helpers
      const getSeries = (p) => {
        if (Array.isArray(p.seria)) return p.seria;
        if (typeof p.seria === "string" && p.seria) return [p.seria];
        if (Array.isArray(p.series)) return p.series;
        if (typeof p.series === "string" && p.series) return [p.series];
        return [];
      };
      const getAuthors = (p) => {
        if (Array.isArray(p.textAutor))
          return p.textAutor.map((a) => a.split(" ")[0].trim());
        if (typeof p.textAutor === "string" && p.textAutor)
          return [p.textAutor.split(" ")[0].trim()];
        return [];
      };

      const matchByRule = (rule, product) => {
        const start = rule.startDate ? new Date(rule.startDate) : null;
        const end = rule.endDate ? new Date(rule.endDate) : null;
        if (end && now > end) return false;
        if (start && now < start) return false;

        const applies = rule.appliesTo || {};
        const matchProduct =
          Array.isArray(applies.products) &&
          applies.products.includes(product.id);

        const productSeries = getSeries(product);
        const matchSeries =
          Array.isArray(applies.series) &&
          productSeries.some((ser) => applies.series.includes(ser));

        const productAuthors = getAuthors(product);
        const ruleAuthors = Array.isArray(applies.authors)
          ? applies.authors.map((a) => a.split(" ")[0].trim())
          : [];
        const matchAuthor = productAuthors.some((a) => ruleAuthors.includes(a));

        return matchProduct || matchSeries || matchAuthor;
      };

      // 3) рахуємо фінальні ціни з урахуванням пріоритетів
      const updated = productsInCart.map((p) => {
        const basePrice = Number(p.price);
        const manualSale =
          p.priceSale !== undefined &&
          p.priceSale !== "" &&
          p.priceSale !== null;

        // знайдемо першу відповідну акцію/розпродаж (аналогічно вашому find)
        const matchedSale = sales.find((s) => matchByRule(s, p));
        const matchedAction = actions.find((a) => matchByRule(a, p));

        let finalPrice = basePrice;
        let flags = {
          isPriceSale: false,
          isSalePrice: false,
          isActionPrice: false,
          isBundlePrice: false,
        };
        let applied = {
          saleDiscountPercent: null,
          actionDiscountPercent: null,
          bundleDiscountPercent: null,
        };

        // 1) priceSale — абсолютний пріоритет
        if (manualSale) {
          finalPrice = Math.round(Number(p.priceSale));
          flags.isPriceSale = true;
        }
        // 2) розпродаж (sales) — якщо нема priceSale
        else if (matchedSale?.discountPercent) {
          const pct = Number(matchedSale.discountPercent) || 0;
          finalPrice = Math.round(basePrice - (basePrice * pct) / 100);
          flags.isSalePrice = true;
          applied.saleDiscountPercent = pct;
        }
        // 3) акція (actions) — якщо нема priceSale і sales
        else if (matchedAction?.discountPercent) {
          const pct = Number(matchedAction.discountPercent) || 0;
          finalPrice = Math.round(basePrice - (basePrice * pct) / 100);
          flags.isActionPrice = true;
          applied.actionDiscountPercent = pct;
        }

        // 4) bundle знижка завжди поверх попереднього результату
        if (p.bundleDiscount) {
          const bPct = Number(p.bundleDiscount) || 0;
          finalPrice = Math.round(finalPrice - (finalPrice * bPct) / 100);
          flags.isBundlePrice = true;
          applied.bundleDiscountPercent = bPct;
        }

        return {
          ...p,
          finalPrice,
          originalPrice: basePrice,
          ...flags,
          ...applied,
        };
      });

      setCartProducts(updated);
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const total = cartProducts.reduce(
      (acc, p) => acc + p.finalPrice * p.quantity,
      0,
    );
    const totalQty = cartProducts.reduce((acc, p) => acc + p.quantity, 0);
    setFinishPrice(total);
    setCountProductForCart(totalQty);
  }, [cartProducts]);

  const cartClose = () => setCart(false);

  const handleQuantityChange = (uid, qty) => {
    const updated = cartProducts.map((p) =>
      p.uid === uid ? { ...p, quantity: qty } : p,
    );

    const cartLS = JSON.parse(localStorage.getItem("cart")).map((p) =>
      p.uid === uid ? { ...p, quantity: qty } : p,
    );
    localStorage.setItem("cart", JSON.stringify(cartLS));
    setCartProducts(updated);
    setCartCounterC((prev) => prev + 1);
  };

  const removeProduct = (uid) => {
    const updated = cartProducts.filter((p) => p.uid !== uid);
    const cartLS = JSON.parse(localStorage.getItem("cart")).filter(
      (p) => p.uid !== uid,
    );
    localStorage.setItem("cart", JSON.stringify(cartLS));
    setCartProducts(updated);
    setCartCounterC((prev) => prev + 1);
  };

  const popUpRefHandler = (e) => {
    if (popUpRef.current && !popUpRef.current.contains(e.target)) {
      cartClose();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", popUpRefHandler);
    return () => document.removeEventListener("mousedown", popUpRefHandler);
  }, []);

  const goToOrder = () => {
    if (cartProducts.length > 0) {
      setCart(false);
      navigate("/order");
    }
  };

  return (
    <div className={css.wrapAllCart}>
      <div className={css.cardWrap}>
        <div className={css.popUpWrap} ref={popUpRef}>
          <div className={css.nameCountWrap}>
            <h2 className={css.countH2}>Ваш кошик ({cartProducts.length})</h2>
            <HandySvg
              onClick={cartClose}
              src={iconSrc}
              width="28"
              height="28"
              className={css.countSvg}
            />
          </div>

          <div className={css.productInCardWrap}>
            {cartProducts.map((el, index) => (
              <ProdInCard
                key={index}
                el={el}
                handleQuantityChange={handleQuantityChange}
                removeProduct={removeProduct}
              />
            ))}
          </div>

          <div className={css.fullPriceBlockWrap}>
            <h3 className={css.finalPrice}>Всього: {finishPrice} грн</h3>
            <div className={css.buttonPriceWrap}>
              <div className={css.nextJoin} onClick={cartClose}>
                Продовжити вибір
              </div>
              <div className={css.finalOrder} onClick={goToOrder}>
                Оформити замовлення
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
